import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/sharp-solid-svg-icons';
import './tab_group_editable.css';

interface SCTabGroupEditableTab {
  Value: string;
  Label: string;
  Closable?: boolean;
  HasError?: boolean;
}

interface SCTabGroupEditableProps {
  Tabs: SCTabGroupEditableTab[];
  Value: string;
  OnChange: (value: string) => void;
  OnClose?: (value: string) => void;
  OnAdd?: () => void;
  AddLabel?: string;
  CanAdd?: boolean;
  AddDisabledTitle?: string;
}

function SCTabGroupEditable({
  Tabs,
  Value,
  OnChange,
  OnClose,
  OnAdd,
  AddLabel = '+ Add child',
  CanAdd = true,
  AddDisabledTitle,
}: SCTabGroupEditableProps) {
  return (
    <div className="sce-tab-group-editable">
      {Tabs.map((tab) => (
        <button
          key={tab.Value}
          type="button"
          className={
            'sce-tge-tab' +
            (tab.Value === Value ? ' active' : '') +
            (tab.HasError ? ' has-error' : '')
          }
          onClick={() => OnChange(tab.Value)}
        >
          <span>{tab.Label}</span>
          {tab.HasError && (
            <span className="sce-tge-error-badge" aria-hidden="true">
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </span>
          )}
          {tab.Closable && OnClose && (
            <span
              className="sce-tge-close"
              onClick={(e) => {
                e.stopPropagation();
                OnClose(tab.Value);
              }}
              title="Remove this level (and any below)"
            >
              ×
            </span>
          )}
        </button>
      ))}
      {OnAdd && (
        <button
          type="button"
          className="sce-tge-add"
          onClick={OnAdd}
          disabled={!CanAdd}
          title={!CanAdd ? AddDisabledTitle : undefined}
        >
          {AddLabel}
        </button>
      )}
    </div>
  );
}

export { SCTabGroupEditable };
export type { SCTabGroupEditableProps, SCTabGroupEditableTab };
